import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/features-shape.png'


const _hoisted_1 = { class: "features-area pt-100 pb-75" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = ["data-aos-delay"]
const _hoisted_5 = { class: "features-single-item position-relative hover-style1 style-two" }
const _hoisted_6 = { class: "hover-style2" }
const _hoisted_7 = {
  href: "https://wa.me/447429916178",
  target: "_blank"
}
const _hoisted_8 = { class: "text-silver" }
const _hoisted_9 = {
  href: "https://wa.me/447429916178",
  target: "_blank",
  class: "read-more style-two"
}
const _hoisted_10 = { class: "count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "section-title mw-860 m-auto text-center",
        "data-aos": "fade-up",
        "data-aos-duration": "1000",
        "data-aos-delay": "100"
      }, [
        _createElementVNode("span", { class: "top-title" }, "لماذا نحن؟"),
        _createElementVNode("h2", null, "ما الذي يجعلنا خيارك الأفضل والفريد؟")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col-xl-4 col-md-6",
            "data-aos": "fade-up",
            "data-aos-duration": "1000",
            "data-aos-delay": 200 + index * 100
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("i", {
                  class: _normalizeClass([feature.icon, "icon"])
                }, null, 2),
                _createElementVNode("h3", null, [
                  _createElementVNode("a", _hoisted_7, _toDisplayString(feature.title), 1)
                ]),
                _createElementVNode("p", _hoisted_8, _toDisplayString(feature.description), 1),
                _createElementVNode("a", _hoisted_9, [
                  _createTextVNode(_toDisplayString(feature.buttonText) + " ", 1),
                  _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ti ti-arrow-left" }, null, -1))
                ]),
                _createElementVNode("span", _hoisted_10, _toDisplayString(index + 1), 1)
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("img", {
                src: _imports_0,
                class: "features-shape",
                alt: "features-shape"
              }, null, -1))
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}